var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4fbf26;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checked_3_",
    "data-name": "checked (3)",
    transform: "translate(-0.002 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20315",
    "data-name": "Group 20315",
    transform: "translate(0.002 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    className: "cls-1",
    d: "M13.5,27a2.257,2.257,0,0,1-.848-.164,2.221,2.221,0,0,1-.743-.492L10.068,24.5a2.806,2.806,0,0,0-.892-.561,2.809,2.809,0,0,0-1.028-.234h-2.6a2.22,2.22,0,0,1-.873-.178,2.274,2.274,0,0,1-1.2-1.2,2.222,2.222,0,0,1-.178-.874v-2.6a2.806,2.806,0,0,0-.234-1.028,2.8,2.8,0,0,0-.561-.893L.657,15.092a2.226,2.226,0,0,1-.492-.744,2.273,2.273,0,0,1,0-1.7,2.221,2.221,0,0,1,.492-.743L2.5,10.068a2.8,2.8,0,0,0,.561-.892,2.808,2.808,0,0,0,.234-1.028v-2.6a2.223,2.223,0,0,1,.178-.874,2.272,2.272,0,0,1,1.2-1.2,2.222,2.222,0,0,1,.873-.177h2.6A2.808,2.808,0,0,0,9.175,3.06a2.81,2.81,0,0,0,.893-.561L11.909.656a2.22,2.22,0,0,1,.743-.492,2.273,2.273,0,0,1,1.7,0,2.219,2.219,0,0,1,.743.492L16.932,2.5a2.811,2.811,0,0,0,.892.562,2.806,2.806,0,0,0,1.028.234h2.6a2.226,2.226,0,0,1,.874.178,2.271,2.271,0,0,1,1.2,1.2,2.225,2.225,0,0,1,.177.874v2.6a2.8,2.8,0,0,0,.234,1.028,2.8,2.8,0,0,0,.561.892l1.841,1.841a2.22,2.22,0,0,1,.492.743,2.275,2.275,0,0,1,0,1.7,2.225,2.225,0,0,1-.492.744L24.5,16.933a3.129,3.129,0,0,0-.8,1.92v2.6a2.223,2.223,0,0,1-.177.874,2.272,2.272,0,0,1-1.2,1.2,2.222,2.222,0,0,1-.874.178H18.852a3.131,3.131,0,0,0-1.92.795l-1.841,1.842a2.221,2.221,0,0,1-.743.492A2.256,2.256,0,0,1,13.5,27ZM9.093,12.3a1.1,1.1,0,0,0-.78,1.883l3,3a1.1,1.1,0,0,0,1.56,0l5.814-5.813a1.1,1.1,0,0,0-1.56-1.56l-5.033,5.033L9.872,12.625A1.1,1.1,0,0,0,9.093,12.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.f60c3ce270abac19fed4b013851e638a.svg";
export { ForwardRef as ReactComponent };